<template>
  <div>
    <el-drawer
      :withHeader="false"
      :visible.sync="drawer"
      direction="rtl"
      size="90%">
      <div class="help-center-container">
        <div class="help-button-column" style="">
          <button class="help-button collapse" @click="drawer = !drawer">帮助</button>
        </div>
        <div class="help-document-container">
          <helpDocument/>
        </div>
      </div>
    </el-drawer>
    <!-- <button class="help-button expand" @click="drawer = !drawer">
      <span>帮助</span>
      <div class="help-video-guideline" v-if="videoData && videoData.length" @click.stop="showHelpPlayer">
        <div class="guideline-outer">
          <div class="guideline-inner">
            <img class="video-cover" :src="videoData[0].videoCover" alt=""/>
            <div class="close-button" @click.stop="videoData = []">
              <i class="el-icon-close"></i>
            </div>
            <div class="video-play">
              <i class="el-icon-video-play"></i>
            </div>
            <div>
              <div class="video-title">{{ videoData[0].videoTitle }}</div>
              <div class="video-time">{{ videoData[0].videoTime }}</div>
            </div>
          </div>
        </div>
      </div>
    </button> -->
    <div style="position: relative;" @click="drawer = !drawer">
      <slot></slot>
      <div class="help-video-guideline" v-if="videoData && videoData.length" @click.stop="showHelpPlayer">
        <div class="guideline-outer">
          <div class="guideline-inner">
            <img class="video-cover" :src="videoData[0].videoCover" alt=""/>
            <div class="close-button" @click.stop="videoData = []">
              <i class="el-icon-close"></i>
            </div>
            <div class="video-play">
              <i class="el-icon-video-play"></i>
            </div>
            <div>
              <div class="video-title">{{ videoData[0].videoTitle }}</div>
              <div class="video-time">{{ videoData[0].videoTime }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <helpPlayer :data="videoData" :visible.sync="helpPlayerShow"/>
  </div>
</template>

<script>
import helpDocument from './helpDocument'
import helpCenterApi from '@/api/helpCenter/helpCenter'
import helpPlayer from './helpPlayer'
export default {
  components: {helpDocument, helpPlayer},
  data() {
    return {
      drawer: false,
      pageGulines: {},
      videoData: [],
      helpPlayerShow: false,
      defaultKey: ''
    }
  },
  watch: {
    $route(to, from) {
      this.videoData = this.pageGulines[to.meta.id] || []
    },
  },
  created() {
    this.getHelpTree()
  },
  methods: {
    showHelpPlayer() {
      this.helpPlayerShow = true
    },
    showHelpDocument() {
      this.drawer = true
    },
    // 获取帮助树
    getHelpTree() {
      this.pageGulines = {}
      helpCenterApi.getTree({ status: '1', helpType: 'OPERATION_MENU' }).then(res => {
        this.generateMenuVideos(res)
        this.videoData = this.pageGulines[this.$route.meta.id]||[]
      }).catch(() => {
      })
    },
    // 创建菜单视频对象
    generateMenuVideos(list) {
      list.forEach(item => {
        if (item.videoUrl && item.relateMenus) {
          item.relateMenus.split(",").forEach(menuId => {
            if (!this.pageGulines[menuId.toString()]) {
              this.pageGulines[menuId.toString()] = []
            }
            this.pageGulines[menuId.toString()].push(item)
          })
        }
        item.childList && item.childList.length && this.generateMenuVideos(item.childList)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-drawer {
  background: transparent !important;
  box-shadow: none;
}
.help-center-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  .help-button-column {
    width: 40px;
    height:100vh;
    position: relative;
  }
}
.help-document-container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.help-button {
  max-width: 40px;
  height: 75px;
  font-size: 20px;
  background-color: #fff;
  border: 1px solid #409EFF;
  border-right: 0;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  cursor: pointer;
  color: #409EFF;
}
.help-button.collapse {
  position: absolute;
  top: 80%;
  left: 0;
}
.help-button.expand {
  max-width: 30px;
  position: fixed;
  right: 0;
  top: 80%;
  // border-radius: 0;
  border-left: none;
  box-shadow: -1px 0 5px 0px #409EFF;
  z-index: 12;
  // &::before {
  //   content: '';
  //   position: absolute;
  //   top: 0;
  //   left: -5px;
  //   width: 5px;
  //   height: 100%;
  //   background: linear-gradient(to right, #40a0ff11, #40a0ff3c, #40a0ff86, #40a0ffdf);
  // }
}
.help-video-guideline {
  width: 190px;
  height: 50px;
  // background: linear-gradient(to right ,#00000068, #000000bb);
  transform: translate(-110%, -50%);
  border-radius: 2px;
  z-index: 999;
  cursor: pointer;
  position: absolute;
  top: 50%;

  &::before {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(100%, -50%);
    border: 8px solid #000000bb;
    border-top-color: transparent;
    border-bottom-color: transparent;
    border-right: none;
  }
  .video-cover {
    position: absolute;
    left: 0;
    height: 100%;
    width: 45%;
    opacity: .5;
  }
  .close-button {
    position: absolute;
    right: 5px;
    color: #fff;
    font-size: 12px;
    padding: 5px;
    width: 10px;
    height: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    &:hover {
      background-color: #ffffff6e;
      color: #000;
      font-weight: bold;
    }
  }
  .video-play {
    font-size: 25px;
    color: #fff;
    width: 45%;
    text-align: center;
  }
  .video-title {
    font-size: 13px;
    color: #fff;
    width: 90px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .video-time {
    font-size: 13px;
    color: #fff;
  }
}
.guideline-outer {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.guideline-inner {
  width: 190px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  background: linear-gradient(to right ,#00000068, #000000bb);
  // transition: transform 10s ease-in-out;
  transform: scaleX(0);
  transform-origin: right;
  animation: toRight .2s ease-in;
  animation-fill-mode: forwards;
}
@keyframes toRight {
  form {
    transform: scaleX(0)
  }
  to {
    transform: scaleX(100%)
  }
}
</style>
